export type CurrencyCode = "SEK" | "EUR" | "USD";

export interface CurrencyConfig {
  code: CurrencyCode;
  symbol: string;
  label: string;
  locale: string;
}

export const CURRENCIES: Record<CurrencyCode, CurrencyConfig> = {
  SEK: { code: "SEK", symbol: "kr", label: "Kr (SEK)", locale: "sv-SE" },
  EUR: { code: "EUR", symbol: "€", label: "€ (EUR)", locale: "de-DE" },
  USD: { code: "USD", symbol: "$", label: "$ (USD)", locale: "en-US" },
};

export const CURRENCY_LIST: CurrencyConfig[] = Object.values(CURRENCIES);

const STORAGE_KEY = "guestly_currency";

export function getStoredCurrency(): CurrencyCode {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && stored in CURRENCIES) return stored as CurrencyCode;
  } catch {}
  return "SEK";
}

export function setStoredCurrency(code: CurrencyCode) {
  try {
    localStorage.setItem(STORAGE_KEY, code);
  } catch {}
}

export type ExchangeRates = Record<string, number>;

export function convertPrice(amountSEK: number, currency: CurrencyCode, rates: ExchangeRates | null): number {
  if (currency === "SEK" || !rates || !rates[currency]) return amountSEK;
  return Math.round(amountSEK * rates[currency]);
}

export function formatDisplayPrice(amountSEK: number, currency: CurrencyCode, rates: ExchangeRates | null): string {
  const converted = convertPrice(amountSEK, currency, rates);
  const config = CURRENCIES[currency];
  if (currency === "SEK") return `${converted} kr`;
  if (currency === "EUR") return `€${converted}`;
  if (currency === "USD") return `$${converted}`;
  return `${converted} ${config.code}`;
}
